import { styled, Typography, alpha, Paper } from '@mui/material';

export const PaperHeaderBox = styled(({...props})=><Paper  {...props}/>)(({ theme }) => {
    return {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',


        [theme.breakpoints.down('sm')]: {
            flexDirection: 'column',
        },
    };
});

export const IconBox = styled('span')(({ theme }) => {
    return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        padding: `${theme.typography.generic.xxxSmall}`,
        marginRight: `${theme.typography.generic.xxxSmall}`,
        borderRadius: theme.typography.borderRadius.small, // 10px
        // backgroundColor: alpha(theme.palette.success.main, 0.08),

        '& svg, & .MuiSvgIcon-root': {
            width: 24,
            height: 24,
            // color: theme.palette.icon.brandPrimary,
        },
    };
});

export const DisplayHeading = styled(Typography)(({ theme }) => {
    return {
        color: theme.palette.text.primary,
        fontSize: theme.typography.customFontSize.xLarge,
        fontWeight: theme.typography.fontWeightMedium,
        lineHeight: '120%',
    };
});
export const StatusTag = styled('span')(({ theme }) => {
    return {
        padding: `${theme.typography.generic.xxxSmall} ${theme.typography.generic.xSmall}`,
        borderRadius: theme.typography.borderRadius.xSmall, // 8px
        color: theme.palette.success.main,
        backgroundColor: alpha(theme.palette.success.main, 0.08),
        marginLeft: theme.typography.generic.small,
        fontFamily: 'Montserrat',
        fontSize: theme.typography.customFontSize.xSmall,
        fontWeight: theme.typography.fontWeightSemiBold,
    };
});
